import React, { useState, useEffect } from "react";
import "../pages/mainPage/mainPage.css";
import "./filters.css";
import filterImg from "./../../assets/filter.png";
import MutltiselectDropdown from "../controls/MutltiselectDropdown";
import FilterDropdown from "../controls/FilterDropdown";
import RangedDate from "../controls/RangedDate";
import InputFilter from "../controls/InputFilter";

const reactSelectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Segoe UI",
    fontSize: "13px",
    fontWeight: "600",
    minHeight: "20px",
    height: "32.5px",
    width: "18.6vw",
    border: "1px solid #888888",
    borderRadius: "0px",
    zIndex: 1,
    boxShadow: state.isFocused ? "0px 0px 0px black" : "none",
    "&:hover": {
      border: "1px solid #888888",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    overflowX: "scroll",
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0,
    },
    flexWrap: "unset",
    zIndex: 10002,
    fontFamily:
      'apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,"Apple Color Emoji","Segoe UI',
    fontSize: "5px",
    fontWeight: "600",
    height: "32px",
    padding: "0px 8px 0px 8px",
    width: "18.5vw",
  }),
  multiValue: (base) => ({
    ...base,
    flex: "1 0 auto",
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
    boxShadow: state.isFocused ? "0px 0px 4px black" : "none",
  }),
  indicatorSeparator: (state) => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "32px",
    top: "6px",
    left: "280px",
  }),
};
const Filters = ({ filterList, onClearAll }) => {
  const [activeFilter, setActiveFilter] = useState(null);

  useEffect(() => {
    const openFilters = [];
    filterList.forEach(filter => {
      if (filter.type === "dropdown" &&
        activeFilter &&
        activeFilter.type === "dropdown" &&
        activeFilter.id === filter.id) {
        openFilters.push(`dropdown:${filter.label}`);
      }
    });

    filterList.forEach(filter => {
      if (filter.type === "multiSelectDropdown" && filter.openDropdown) {
        openFilters.push(`multiSelectDropdown:${filter.label}`);
      }
    });

    filterList.forEach(filter => {
      if (filter.type === "dateRange" && filter.showCalender) {
        openFilters.push(`dateRange:${filter.label}`);
      }
    });

  }, [activeFilter, filterList]);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      const isOutside =
        !event.target.closest(".react-select__menu") &&
        !event.target.closest(".react-select__control") &&
        !event.target.closest(".calendar-container") &&
        !event.target.closest(".multi-select-container");

      if (isOutside) {
        closeAllDropdowns();
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  const closeAllDropdowns = () => {
    setActiveFilter(null);
    
    filterList.forEach(filter => {
      if (filter.type === "multiSelectDropdown" && filter.openDropdown) {
        if (typeof filter.onClick === "function") {
          filter.onClick();
        }
      }
    });

    filterList.forEach((filter) => {
      if (filter.type === "dateRange" && filter.showCalender) {
        if (typeof filter.setShowCalender === "function") {
          filter.setShowCalender(false);
        }
      }
    });
  };

  const openDropdownAndCloseOthers = (filterId, filterType, filterLabel) => {
    setActiveFilter({
      id: filterId,
      type: filterType,
      label: filterLabel,
    });

    filterList.forEach((otherFilter) => {
      if (
        (otherFilter.type === "dropdown" || otherFilter.type === "multiSelectDropdown") &&
        otherFilter.id !== filterId
      ) {
        if (typeof otherFilter.onClick === "function") {
          otherFilter.onClick(); // Close dropdown
        }
      }

      if (
        otherFilter.type === "dateRange" &&
        otherFilter.showCalender &&
        otherFilter.id !== filterId
      ) {
        if (typeof otherFilter.setShowCalender === "function") {
          otherFilter.setShowCalender(false); 
        }
      }
    });
  };

  const handleDropdownClick = (filter) => {
    return () => {
      if (activeFilter && activeFilter.id === filter.id && activeFilter.type === "dropdown") {
        setActiveFilter(null);
      } else {
        openDropdownAndCloseOthers(filter.id, "dropdown", filter.label);
      }
    };
  };
  const handleMultiSelectClick = (filter) => {
    return (event) => {
      if (event.target.closest('.multi-select-container') || 
          event.target.closest('.react-select__control')) {
        
        if (!filter.openDropdown) {
          openDropdownAndCloseOthers(filter.id, "multiSelectDropdown", filter.label);
        } else if (activeFilter && activeFilter.id === filter.id && activeFilter.type === "multiSelectDropdown") {
          setActiveFilter(null);
        }
        filter.onClick();
      }
    };
  };
  const handleDatePickerClick = (filter) => {
    return () => {
      filterList.forEach((otherFilter) => {
        if (
          otherFilter.type === "dateRange" &&
          otherFilter.id !== filter.id &&
          otherFilter.showCalender &&
          typeof otherFilter.setShowCalender === "function"
        ) {
          otherFilter.setShowCalender(false);
        }
      });
      if (typeof filter.setShowCalender === "function") {
        filter.setShowCalender(!filter.showCalender);
      }
      setActiveFilter({
        id: filter.id,
        type: "dateRange",
        label: filter.label,
      });
    };
  };

  const handleClearAll = () => {
    closeAllDropdowns();
    onClearAll();
  };

  return (
    <>
      <div className="heading-container">
        <div className="image-container">
          <img src={filterImg} alt="Filter Icon" />
        </div>
        <div className="sub-heading">Filters</div>
        <div className="clear-all" onClick={handleClearAll}>
          Clear All
        </div>
      </div>
      <div className="filters-grid">
        {filterList.map((filter, index) => {
          switch (filter.type) {
            case "dropdown":
              return (
                <FilterDropdown
                  key={filter.id || index}
                  options={filter.options}
                  selectedOptions={filter.selectedOptions}
                  onChange={filter.onChange}
                  value={filter.value}
                  placeholder={filter.placeholder}
                  label={filter.label}
                  id={filter.id}
                  reactSelectCustomStyles={reactSelectCustomStyles}
                  zIndex={filter.zIndex}
                  onClick={handleDropdownClick(filter)}
                  isOpen={activeFilter && activeFilter.id === filter.id && activeFilter.type === "dropdown"}
                  onToggle={(isOpen) => {
                    if (isOpen) {
                      openDropdownAndCloseOthers(filter.id, "dropdown", filter.label);
                    } else if (activeFilter && activeFilter.id === filter.id) {
                      setActiveFilter(null);
                    }
                  }}
                />
              );

            case "dateRange":
              return (
                <RangedDate
                  key={filter.id || index}
                  ref={filter.ref}
                  setShowCalender={handleDatePickerClick(filter)}
                  reactSelectCustomStyles={reactSelectCustomStyles}
                  onChange={filter.onChange}
                  showCalender={filter.showCalender}
                  label={filter.label}
                  id={filter.id}
                  value={filter.value}
                  placeholder={filter.placeholder}
                  renderKey={filter.renderKey}
                  onDateSelect={filter.onDateSelect}
                  datePickerValue={filter.datePickerValue}
                />
              );
            case "multiSelectDropdown":
              return (
                <MutltiselectDropdown
                  key={filter.id || index}
                  ref={filter.ref}
                  label={filter.label}
                  placeholder={filter.placeholder}
                  reactSelectCustomStyles={reactSelectCustomStyles}
                  value={filter.value}
                  id={filter.id}
                  onChange={filter.onChange}
                  options={filter.options}
                  onClick={handleMultiSelectClick(filter)}
                  openDropdown={filter.openDropdown}
                  zIndex={filter.zIndex || '998'}
                />
              );

            case "inputText":
              return (
                <InputFilter
                  key={filter.id || index}
                  label={filter.label}
                  placeholder={filter.placeholder}
                  value={filter.value}
                  onChange={filter.onChange}
                  id={filter.id}
                />
              );

            default:
              return (
                <InputFilter
                  key={filter.id || index}
                  label={filter.label}
                  placeholder={filter.placeholder}
                  value={filter.value}
                  onChange={filter.onChange}
                  id={filter.id}
                />
              );
          }
        })}
      </div>
    </>
  );
};

export default Filters;